// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  language: '',
  url_portal: 'totvshealthplans',
  version: 'v1.0(231114)',

  // Mingle
  app_identifier: '67ffa5af409b19e3486ea44a',
  environment: 'DEV',
  server: 'https://dev-mingle.totvs.com.br',
  web: true,
  usage_metrics: true,
  gateway: true,
  ocr: false,
  crashr: false,
  push_notification: false
};

//Endpoints Auditoria Pos
const MAX_RETRY_ATTEMPTS = 5;
const API_LOCATION = 'https://10.171.40.51:4200/api/healthcare/hatfaturamento/v1/';
const API_BASE = 'https://api.carol.ai/';
const CHAT_API = 'https://10.171.40.51:4200/api/healthcare/hatChat/v1/';
const ORGANIZATION = 'deepaudit';
const ENVIRONMENT = 'posauditdev';
const SUSEP = '888888';//349682
const IDTENANT = '5';
const TENANTNAME = 'suporte';//caberj

export const environmentAuditPos = {
  production: false,    
  maxRetryAttempts: MAX_RETRY_ATTEMPTS,    
  apiEndPoint: API_LOCATION,
  apiChatEndPoint: CHAT_API,
  apiBase: API_BASE,
  organization: ORGANIZATION,
  environment: ENVIRONMENT,
  susep: SUSEP,
  idtenant: IDTENANT,
  tenantname: TENANTNAME,
  api: {
      target: "https://"+ORGANIZATION+".carol.ai",
      secure:true,
      logLevel: "debug",
      changeOrigin: true
  }
};
